'use client';

import { useGetBetTypeSetting } from '@/hooks';
import { useSiteStore } from '@/store/site'
import { MaybeMatch } from '@nf/utils-common/fpw/monadic';
import { objectEmptyCheck } from '@nf/utils-common/fpw/utils';
import { useTranslations } from 'next-intl';

interface ListHeaderProps {
    sport: number
}

export const ListHeader = ({ sport }: ListHeaderProps) => {
	const [betTypeFilterCriterion] = useSiteStore(state => [state.getBetTypeFilterCriterion(sport)]);
	const getBetTypeSetting = useGetBetTypeSetting();
	const betTypeSetting = getBetTypeSetting((betTypeFilterCriterion && Array.isArray(betTypeFilterCriterion.betTypes)) ? betTypeFilterCriterion.betTypes[0] : 0, sport);
	const t = useTranslations('General');
	if (!betTypeSetting) return;
	const choiceDispaySetting = betTypeSetting?.betChoiceDisplaySetting ?? {};
	const headerColumns: string[] = objectEmptyCheck(choiceDispaySetting).fold(
		() => betTypeSetting.betChoices.map(betChoice => betChoice.label), 
		() => betTypeSetting.betChoices.reduce((accumulator, currentValue) => {
			const displayLabel = choiceDispaySetting[currentValue.betTeam].label;
			return MaybeMatch(accumulator.includes(displayLabel))
				.fold(
					() => {
						accumulator.push(displayLabel);
						return accumulator;
					},
					() => accumulator
				)
		}, [] as string[])
	);
	
	return (
		<div className="league-header__bettypes">
			{
				headerColumns.map((column) => {
					return (
						<div 
							key={`${column}`}
							className="league-header__bettype"
						>
							{t(column)}
						</div>
					)
				})
			}
		</div>
	)
}